export default __webpack_public_path__ + "static/media/Logo.93279fef.svg";